import { gql } from "@apollo/client";

export const SUBSCRIPTION_CREATE = gql`
  mutation SubscriptionCreate($input: SubscriptionCreateInput!) {
    subscriptionCreate(input: $input) {
      errors {
        code
        field
        message
      }
    }
  }
`;
